module.exports = __webpack_public_path__ + "072d1eca8b82ae6fb3316353274db1e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/browser/app-store-apple.png
// module id = 1444
// module chunks = 24